import React from 'react';
const taskImg = process.env.PUBLIC_URL + '/task.png';
const taskDoneImg = process.env.PUBLIC_URL + '/task_done.png';
import logo from '../netgen_logo.png';

export default function Banner({ onIconClick, onLogoClick, hasDone, runningCount, user, onLogout }) {
  return (
    <div className="banner">
      <img
        src={logo}
        alt="NetGen"
        className="banner-logo"
        onClick={onLogoClick}
      />
      <div className="banner-spacer" />
      <div className="banner-tasks">
        <span className="task-count">{runningCount}</span>
        <img
          src={hasDone ? taskDoneImg : taskImg}
          alt="tasks"
          className="task-icon"
          onClick={onIconClick}
        />
      </div>
      {onLogout && (
        <button
          className="banner-logout"
          onClick={onLogout}
          title={`Logged in as ${user?.preferred_username || ''}`}
        >
          Log out
        </button>
      )}
    </div>
  );
}
